import React, { useEffect, useRef, useState } from 'react';
import { FaPhone, FaMapMarkerAlt, FaClock, FaInstagram, FaTiktok, FaFacebookF } from 'react-icons/fa';
import { useLanguage } from '../context/LanguageContext';
import '../styles/Contact.css';

function Contact() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const { t } = useLanguage();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="contact-section" ref={sectionRef}>
      <div className="contact-container">
        <div className={`contact-header ${isVisible ? 'visible' : ''}`}>
          <h2 className="section-title">{t('contact.title')}</h2>
          <p className="section-subtitle">{t('contact.subtitle')}</p>
        </div>

        <div className={`contact-content ${isVisible ? 'visible' : ''}`}>
          {/* Contact Cards */}
          <div className="contact-cards">
            <div className="contact-card phone-card">
              <div className="card-icon">
                <FaPhone />
              </div>
              <h3 className="card-title">{t('contact.phone')}</h3>
              <a href="tel:+35797797754" className="card-value phone-link">
                <FaPhone className="phone-inline-icon" />
                <span>97 797754</span>
              </a>
              <span className="tap-hint">{t('contact.tapToCall')}</span>
            </div>

            <div className="contact-card">
              <div className="card-icon">
                <FaMapMarkerAlt />
              </div>
              <h3 className="card-title">{t('contact.location')}</h3>
              <p className="card-value">{t('contact.locationText')}</p>
              <a 
                href="https://www.google.com/maps/dir/?api=1&destination=Maya's+Flavours,+Lefkosias+11,+Latsia,+Cyprus" 
                target="_blank" 
                rel="noopener noreferrer"
                className="card-link"
              >
                {t('contact.findUs')} →
              </a>
            </div>

            <div className="contact-card">
              <div className="card-icon">
                <FaClock />
              </div>
              <h3 className="card-title">{t('contact.hours')}</h3>
              <div className="hours-list">
                <div className="hours-row">
                  <span>{t('contact.monFri')}</span>
                  <span>10:00 - 21:00</span>
                </div>
                <div className="hours-row">
                  <span>{t('contact.saturday')}</span>
                  <span>10:00 - 20:00</span>
                </div>
                <div className="hours-row">
                  <span>{t('contact.sunday')}</span>
                  <span>{t('contact.closed')}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Social Media Section */}
          <div className="social-section">
            <h3 className="social-title">{t('contact.followUs')}</h3>
            <div className="social-links">
              <a 
                href="https://www.instagram.com/mayas_flavours/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link instagram"
                aria-label="Instagram"
              >
                <FaInstagram />
                <span>Instagram</span>
              </a>
              <a 
                href="https://www.tiktok.com/@mayasflavours" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link tiktok"
                aria-label="TikTok"
              >
                <FaTiktok />
                <span>TikTok</span>
              </a>
              <a 
                href="https://www.facebook.com/MayasFlavours" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link facebook"
                aria-label="Facebook"
              >
                <FaFacebookF />
                <span>Facebook</span>
              </a>
            </div>
          </div>

          {/* Map Section */}
          <div className="map-section">
            <a 
              href="https://www.google.com/maps/dir/?api=1&destination=Maya's+Flavours,+Lefkosias+11,+Latsia,+Cyprus" 
              target="_blank" 
              rel="noopener noreferrer"
              className="map-card"
            >
              <div className="map-card-content">
                <div className="map-icon-wrapper">
                  <FaMapMarkerAlt className="map-pin-icon" />
                </div>
                <div className="map-card-info">
                  <h4>Maya's Flavours</h4>
                  <p>Lefkosias 11, Latsia, Cyprus</p>
                  <span className="map-cta">{t('contact.findUs')} →</span>
                </div>
              </div>
              <div className="map-card-decoration"></div>
            </a>
          </div>
        </div>
      </div>

      {/* Background Decorations */}
      <div className="contact-decoration contact-deco-1"></div>
      <div className="contact-decoration contact-deco-2"></div>
    </div>
  );
}

export default Contact;
